import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './heroImageUpload.css';

const MAX_FILE_SIZE = 4 * 1024 * 1024;

export const getHeroImagePreviewSrc = (headerImage) => {
  if (!headerImage) {
    return '';
  }

  const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
  if (!cloudName) {
    return headerImage;
  }

  return `https://res.cloudinary.com/${cloudName}/image/fetch/t_form_banner/${encodeURI(headerImage)}`;
};

class HeroImageUpload extends PureComponent {
  state = {
    loading: false,
    uploading: false,
    error: null,
  };

  handleUploadClick = () => {
    const { disabled, onHeaderImageChange } = this.props;
    if (disabled) {
      return;
    }

    const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
    const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

    if (!cloudName || !uploadPreset || !window.cloudinary) {
      this.setState({ error: 'Image upload is not available right now' });
      return;
    }

    this.setState({ error: null, loading: true });

    const widget = window.cloudinary.createUploadWidget(
      {
        cloudName,
        uploadPreset,
        maxFileSize: MAX_FILE_SIZE,
        multiple: false,
        resourceType: 'image',
        clientAllowedFormats: null,
        showPoweredBy: false,
        sources: ['local'],
        singleUploadAutoClose: true,
      },
      (err, result) => {
        if (err) {
          this.setState({ uploading: false, error: err.message || 'Upload failed' });
          return;
        }

        if (result.event === 'show') {
          this.setState({ loading: false });
        }

        if (result.event === 'queues-start') {
          this.setState({ uploading: true });
        }

        if (result.event === 'success') {
          onHeaderImageChange(result.info.secure_url);
        }

        if (result.event === 'close') {
          this.setState({ loading: false, uploading: false });
        }
      },
    );

    widget.open();
  };

  handleRemove = () => {
    const { onHeaderImageChange } = this.props;
    this.setState({ error: null });
    onHeaderImageChange('');
  };

  render() {
    const { headerImage, disabled } = this.props;
    const { loading, uploading, error } = this.state;
    const previewSrc = getHeroImagePreviewSrc(headerImage);
    const isBusy = loading || uploading;

    return (
      <div className="hero-image-upload">
        {headerImage && (
          <div className="hero-image-upload__preview">
            <img alt="Hero banner preview" src={previewSrc} />
          </div>
        )}

        <div className="hero-image-upload__actions">
          <button
            type="button"
            className="hero-image-upload__upload-btn"
            onClick={this.handleUploadClick}
            disabled={disabled || isBusy}
          >
            {/* eslint-disable-next-line no-nested-ternary */}
            {loading ? 'Opening...' : (uploading ? 'Uploading...' : (headerImage ? 'Replace image' : 'Upload image'))}
          </button>

          {headerImage && (
            <button
              type="button"
              className="hero-image-upload__remove-btn"
              onClick={this.handleRemove}
              disabled={disabled || isBusy}
            >
              Remove
            </button>
          )}
        </div>

        {error && (
          <p className="hero-image-upload__error">{error}</p>
        )}
      </div>
    );
  }
}

HeroImageUpload.defaultProps = {
  headerImage: '',
  disabled: false,
};

HeroImageUpload.propTypes = {
  headerImage: PropTypes.string,
  disabled: PropTypes.bool,
  onHeaderImageChange: PropTypes.func.isRequired,
};

export default HeroImageUpload;
